/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

﻿__webpack_require__(0);
var explorer = navigator.userAgent ;
if (explorer.indexOf("MSIE") >= 0) {
    if(navigator.userAgent.indexOf("MSIE 6.0")>0){
        alert("您使用的浏览器内核版本为IE6，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 7.0")>0){
        alert("您使用的浏览器内核版本为IE7，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 9.0")>0 && !window.innerWidth){
        alert("您使用的浏览器内核版本为IE8，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 9.0")>0){
        alert("您使用的浏览器内核版本为IE9，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
}

function navClick(e,n){
    $(e).siblings('li').removeClass('actv');
    $(e).addClass('actv');
    $('#fp-nav ul li:nth-child('+n+') a').click();
}

    
/* 替换图片地址即可，一般从服务器动态获取 */
/*图片数组，用来动态计算有几个bn图(目前写死)*/
var images = ['./imgs/1.jpg','./imgs/2.jpg','./imgs/3.jpg'];
var n = 0,inte='';

$('div.bottom i').click(function(){carouselN(parseInt($(this).attr('name')))})
$('div.rmleft').click(function(){carouselN(n-1)})
$('div.rmright').click(function(){carouselN(n+1)})

function carouselN(x){
    clearInterval(inte);
    var w = $(window).width();
    n=x;
    if(x>images.length-1){n=0}
    if(x<0){n=images.length-1}
    $('div.bottom i').css('background', '#fff');
    $('div.bottom i').eq(n).css({'background':'#000','border':'1px solid #fff'});
    console.log(n)
    if(n==0){
        $('#Carousel div img').css('left', '0')
    }else{
        $('#Carousel div img').css('left', -n * w-5);
    }
    carousel();
}

function carousel() {
    inte = setInterval(function () {
        n > images.length ? n = 0 : n;
        carouselN(n);
        n++;
    }, 5000);
}

$(window).resize(function(){
    carouselN(n)
})

// $(function(){
//     carousel()
// })

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/index.js